var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rd-wrap" }, [
    _c("div", { staticClass: "rd-toolbar" }, [
      _c(
        "span",
        { staticClass: "rd-toolbar__title" },
        [
          _vm._v("\n      " + _vm._s(_vm.field.title) + "\n      "),
          _vm.field.help_text
            ? _c("help-text", { attrs: { text: _vm.field.help_text } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "rd-toggle",
          class: { "rd-toggle--on": _vm.show_value }
        },
        [
          _c("el-checkbox", {
            model: {
              value: _vm.show_value,
              callback: function($$v) {
                _vm.show_value = $$v
              },
              expression: "show_value"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("Values")])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "rd-col-headers" }, [
      _c("span", { staticClass: "rd-col-headers__spacer" }),
      _vm._v(" "),
      _c("span", [_vm._v("Label")]),
      _vm._v(" "),
      _vm.show_value ? _c("span", [_vm._v("Value")]) : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "rd-list option-field-swapper" },
      _vm._l(_vm.options, function(option, index) {
        return _c("li", { key: index, staticClass: "rd-row" }, [
          _vm._m(0, true),
          _vm._v(" "),
          _c("span", { staticClass: "rd-row__selector" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected,
                  expression: "selected"
                }
              ],
              staticClass: "rd-check",
              attrs: { type: "radio" },
              domProps: {
                value: option.value,
                checked: _vm._q(_vm.selected, option.value)
              },
              on: {
                change: function($event) {
                  _vm.selected = option.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rd-row__label" },
            [
              _c("el-input", {
                attrs: { size: "small", placeholder: "Label" },
                on: {
                  input: function($event) {
                    return _vm.sync_label(index, option.label)
                  }
                },
                model: {
                  value: option.label,
                  callback: function($$v) {
                    _vm.$set(option, "label", $$v)
                  },
                  expression: "option.label"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.show_value
            ? _c(
                "div",
                { staticClass: "rd-row__value" },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "value" },
                    model: {
                      value: option.value,
                      callback: function($$v) {
                        _vm.$set(option, "value", $$v)
                      },
                      expression: "option.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "rd-row__actions" }, [
            _c("i", {
              staticClass: "el-icon-circle-plus rd-btn-add",
              attrs: { title: "Add row" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.add_option($event)
                }
              }
            }),
            _vm._v(" "),
            _vm.options.length > 1
              ? _c("i", {
                  staticClass: "el-icon-remove rd-btn-del",
                  attrs: { title: "Remove" },
                  on: {
                    click: function($event) {
                      return _vm.delete_option(index)
                    }
                  }
                })
              : _vm._e()
          ])
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "rd-footer" }, [
      _c(
        "button",
        {
          staticClass: "rd-add-btn",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.add_option($event)
            }
          }
        },
        [_c("i", { staticClass: "el-icon-plus" }), _vm._v(" Add Row\n    ")]
      ),
      _vm._v(" "),
      _vm.selected
        ? _c(
            "button",
            {
              staticClass: "rd-clear-btn",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.clear_selection($event)
                }
              }
            },
            [
              _c("i", { staticClass: "el-icon-close" }),
              _vm._v(" Clear Default\n    ")
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "rd-row__drag" }, [
      _c("i", { staticClass: "el-icon-more rd-drag-icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }